import { useEffect, useMemo } from "react"

import { useNavigate } from "react-router-dom"

import {
    type OneVerifyPermission,
    PermissionsExistenceLogicalOperator,
} from "@common-shared/config/rolesPermissions.config.ts"

import { ROUTES_CONFIG } from "../config/routes.config"
import { PermissionsHelper } from "../helpers/permissions.helper"
import { UtilHelper } from "../helpers/util.helper.tsx"
import { useAppSelector } from "../store/selectors/app.selector"
import { selectedPracticeRoleSelector } from "../store/selectors/selectedPracticeRole.selector"

export const useHasPermissions = (
    accessAllowedPermissions: OneVerifyPermission | OneVerifyPermission[],
    permissionsExistenceOperator?: PermissionsExistenceLogicalOperator,
    withRedirectOnMissingPermission = true,
): boolean | null => {
    const navigate = useNavigate()
    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)

    const hasPermission = useMemo<boolean | null>(() => {
        return selectedPracticeRole
            ? PermissionsHelper.hasPermission(
                  accessAllowedPermissions,
                  selectedPracticeRole,
                  permissionsExistenceOperator,
              )
            : null
    }, [
        selectedPracticeRole,
        accessAllowedPermissions,
        permissionsExistenceOperator,
    ])

    useEffect(() => {
        if (hasPermission !== false || !withRedirectOnMissingPermission) {
            return
        }

        UtilHelper.redirectTo(ROUTES_CONFIG.baseApplicationUrl, navigate)
    }, [hasPermission, withRedirectOnMissingPermission])

    return hasPermission
}
